<template>
    <x-page title="User Role">
        <template #header-actions>
            <x-create-button
                url="/admin/user-roles/create"
                :disabled="isLoading"
                v-if="can('createUserRoles')"
            />
        </template>
        <x-table :headers="['Label', 'Users', '']" :is-loading="isLoading">
            <tr v-for="(role, index) in roles" :key="index">
                <td>
                    <router-link
                        :to="`/admin/user-roles/${role.id}`"
                        title="Klik untuk lihat detail"
                    >
                        {{ role.label }}
                    </router-link>
                    <div v-if="role.is_default">
                        <span class="label label-info">Default</span>
                    </div>
                </td>
                <td>
                    <a href="javascript:;" @click.prevent="showUserModal(role)">
                        Lihat detail ({{ role.users_count | number }})
                    </a>
                </td>
                <td>
                    <x-quick-edit-button
                        :url="`/admin/user-roles/${role.id}/edit`"
                        :disabled="isLoading"
                        v-if="can('updateUserRoles')"
                    />
                    <x-quick-delete-button
                        @click="deleteResource(role)"
                        :disabled="isLoading"
                        v-if="can('deleteUserRoles')"
                    />
                </td>
            </tr>
        </x-table>

        <x-pagination v-if="shouldRenderPagination" :pagination="meta" />
        <user-modal id="user-modal" :role="highlightedRole" />
    </x-page>
</template>

<script>
import XCreateButton from "../../components/XCreateButton.vue";
import XQuickDeleteButton from "../../components/XQuickDeleteButton.vue";
import XQuickEditButton from "../../components/XQuickEditButton.vue";
import XPage from "../../components/XPage.vue";
import XTable from "../../components/XTable.vue";
import { deletePrompt, handleGeneralXhrError } from "../../helpers";
import PaginationMixin from "../../mixins/PaginationMixin";
import PermissionMixin from "../../mixins/PermissionMixin";
import UserModal from "./UserModal.vue";
import { pickBy } from "lodash";
import XPagination from "../../components/XPagination.vue";
import FilterableMixin from "../../mixins/FilterableMixin";

export default {
    beforeRouteUpdate(to, from, next) {
        this.fetchResources(to);
        next();
    },
    components: {
        XCreateButton,
        XTable,
        XQuickEditButton,
        XQuickDeleteButton,
        XPage,
        UserModal,
        XPagination,
    },
    created() {
        this.preselectFilters();
        this.handleFilter(1, true).catch(() => {
            this.fetchResources();
        });
    },
    data() {
        return {
            highlightedRole: null,
            isLoading: false,
            roles: [],
        };
    },
    methods: {
        deleteResource(role) {
            deletePrompt({
                name: role.label,
                onConfirm: () => {
                    this.isLoading = true;
                    const request = axios
                        .delete(`/api/user-roles/${role.id}`)
                        .then(() => {
                            this.$notify({
                                type: "success",
                                title: `Berhasil`,
                                text: `${role.label} dihapus!`,
                            });
                            this.fetchResources();
                        });
                    handleGeneralXhrError(request).finally(() => {
                        this.isLoading = false;
                    });
                },
            });
        },
        fetchResources(route = this.$route) {
            this.isLoading = true;
            const request = axios
                .get("/api/user-roles", {
                    params: pickBy({
                        ...route.query,
                        with_count: ["users"],
                    }),
                })
                .then((response) => {
                    this.roles = response.data.data;
                    this.setMeta(response);
                });
            return handleGeneralXhrError(request).finally(() => {
                this.isLoading = false;
            });
        },
        showUserModal(role) {
            this.highlightedRole = role;
            $("#user-modal").modal("show");
        },
    },
    mixins: [FilterableMixin, PaginationMixin, PermissionMixin],
};
</script>
